import { render, staticRenderFns } from "./customer-following-system.vue?vue&type=template&id=5e9f2c20"
import script from "./customer-following-system.vue?vue&type=script&lang=js"
export * from "./customer-following-system.vue?vue&type=script&lang=js"
import style0 from "./customer-following-system.vue?vue&type=style&index=0&id=5e9f2c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports